import React, { FunctionComponent, ReactElement, Ref } from 'react'
import { FieldRenderProps } from 'react-final-form'
import { TextStyle, ViewStyle } from 'react-native'

import CSS from 'csstype'
import styled from 'styled-components/native'

import { BaseInput } from './BaseInput'
import { TokenTextInput, TokenTextInputRef } from '../tokenTextInput/TokenTextInput.web'
import { ToolTipTriggerConfig } from '../tooltip/Tooltip'

// Add a styled wrapper for TokenTextInput
const StyledTokenTextInputContainer = styled.View(({ theme }) => ({
  backgroundColor: theme.colors.inputBackgroundDefault,
  border: '1px solid',
  borderColor: theme.colors.inputOutlineDefault,
  borderRadius: '4px',
  overflow: 'hidden',
  padding: theme.spacing['8px'],
}))

export interface TokenInputFieldRFFProps extends FieldRenderProps<string> {
  label?: string
  subLabel?: string
  subLabelComponent?: string
  baseInputStyle?: ViewStyle
  toolTipContent?: string | ReactElement
  toolTipTriggerConfig?: ToolTipTriggerConfig
  labelStyle?: ViewStyle
  labelContainerStyle?: ViewStyle
  isOptionalLabel?: boolean
  toolTipContentStyle?: { container?: Dict }
  toolTipHoverEnabled?: boolean
  showErrorAsWarning?: boolean
  // Additional BaseInput props that might be useful
  labelAlignment?: CSS.Properties['alignItems']
  labelSecondary?: string
  largeLabel?: boolean
  largeSubLabel?: boolean
  hideErrorPadding?: boolean
  hideErrorMessage?: boolean
  showDivider?: boolean
  customTextStyle?: TextStyle
  inputRef?: Ref<TokenTextInputRef>
  inputContainerStyle?: ViewStyle
  handleChange?: (value: string) => void
  fixedHeight?: string
}

export const TokenInputFieldRFF: FunctionComponent<TokenInputFieldRFFProps> = ({
  input: { value, name },
  meta: { touched, error, submitError, dirtySinceLastSubmit },
  label,
  subLabel,
  subLabelComponent,
  baseInputStyle,
  toolTipContent,
  toolTipTriggerConfig,
  labelStyle,
  labelContainerStyle,
  isOptionalLabel,
  toolTipContentStyle,
  toolTipHoverEnabled,
  showErrorAsWarning,
  labelAlignment,
  labelSecondary,
  largeLabel,
  largeSubLabel,
  hideErrorPadding,
  hideErrorMessage,
  showDivider,
  customTextStyle,
  inputRef,
  inputContainerStyle,
  handleChange,
  fixedHeight,
}) => {
  return (
    <BaseInput
      label={label}
      labelStyle={labelStyle}
      labelContainerStyle={labelContainerStyle}
      isOptionalLabel={isOptionalLabel}
      subLabel={subLabel}
      subLabelComponent={subLabelComponent}
      error={touched && (error || (!dirtySinceLastSubmit && submitError))}
      name={name}
      style={baseInputStyle}
      toolTipContent={toolTipContent}
      toolTipTriggerConfig={toolTipTriggerConfig}
      toolTipContentStyle={toolTipContentStyle}
      toolTipHoverEnabled={toolTipHoverEnabled}
      showErrorAsWarning={showErrorAsWarning && !dirtySinceLastSubmit && !!submitError}
      labelAlignment={labelAlignment}
      labelSecondary={labelSecondary}
      largeLabel={largeLabel}
      largeSubLabel={largeSubLabel}
      hideErrorPadding={hideErrorPadding}
      hideErrorMessage={hideErrorMessage}
      showDivider={showDivider}
      customTextStyle={customTextStyle}
    >
      <StyledTokenTextInputContainer style={inputContainerStyle}>
        <TokenTextInput ref={inputRef} initialValue={value} onChange={handleChange} fixedHeight={fixedHeight} />
      </StyledTokenTextInputContainer>
    </BaseInput>
  )
}
